import { IPersona } from '@/types';

export const mockPersonas: IPersona[] = Array.from({ length: 4 }, (_, i) => {
  return {
    id: i + 1,
    name: `Persona ${i + 1}`,
    description: `This is a brief background description for Persona ${i + 1}, highlighting their professional journey and key experiences. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Persona ${i + 1} has a strong track record in their field and is eager to improve their skills through role-play simulations.`,
    imageUrl: `https://randomuser.me/api/portraits/${i % 2 === 0 ? 'men' : 'women'}/${i + 10}.jpg`,
    uuid: `persona-${i + 1}`,
  };
});
